/* @flow */
import * as React from 'react';
import cx from 'classnames';

import AllPIIDownloadSection from './AllPIIDownloadSection';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import Divider from 'components/Divider';
import ErrorReporter from 'app/components/ErrorReporter';
import OwnedGroupSummariesFetcher from 'groups/containers/OwnedGroupSummariesFetcher';
import PrintAnnouncements from './PrintAnnouncements';
import PrintSubscribers from './PrintSubscribers';

type Props = {
  className?: string,
};

export default function PrintSettingsView(props: Props) {
  return (
    <OwnedGroupSummariesFetcher>
      {({ ownedGroups, loading, error }) => {
        if (loading) {
          return <CenteredLoadingIndicator />;
        }

        if (error || !ownedGroups) {
          return <ErrorReporter error="PrintSettingsView - failed to fetch owned groups" />;
        }

        return (
          <div className={cx('PrintSettingsView', props.className)}>
            <PrintAnnouncements groups={ownedGroups} />
            <Divider />
            <PrintSubscribers groups={ownedGroups} />
            <Divider />
            <AllPIIDownloadSection />
            <Divider />
          </div>
        );
      }}
    </OwnedGroupSummariesFetcher>
  );
}
